import {useContext, useMemo} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import Icon from 'components/Icon';
import classNames from 'classnames';
import {useRouter} from 'next/router';
import {useReviewsTotal} from 'modules/products/hooks/useReviewsTotal';
import {ProductReviewContext} from 'modules/products/context/ProductReview';

const PERCENT_VALUE = 100;

export const RatingMarksStatistics = () => {
    const {query} = useRouter();
    const total = useReviewsTotal({code: query.code as string});
    const {createOnFilterClickHandler} = useContext(ProductReviewContext);

    const assessments = useMemo(() => (total ? [...total.assessments].sort((a, b) => b.title - a.title) : []), [total]);

    return (
        <>
            {assessments.map(({title, count}) => {
                return (
                    <div
                        className={classNames(style.markItem, {[style.disabled]: !count})}
                        key={title}
                        onClick={() => {
                            if (!count) {
                                return;
                            }
                            createOnFilterClickHandler(title)();
                        }}
                    >
                        <Typography className={style.number} color={'gray60'}>
                            {title}
                        </Typography>
                        <Icon className={style.starIcon} icon={'star'} />
                        <div className={style.scale}>
                            <div
                                className={style.filler}
                                style={{
                                    width: Boolean(total?.assessmentsCount)
                                        ? `${Math.floor(PERCENT_VALUE * count) / total.assessmentsCount}%`
                                        : 0,
                                }}
                            />
                        </div>
                        <Typography className={style.markValue} color={count ? 'black100' : 'gray60'} element={'div'}>
                            {count}
                        </Typography>
                    </div>
                );
            })}
        </>
    );
};
